@use "@/styles/variables" as *;

.table {
	width: 100%;
	border-collapse: collapse;
	font-size: 0.875rem;
}

.headerRow {
	border-bottom: 2px solid $gray-200;
}

.headerCell {
	padding: 8px 12px;
	font-weight: 600;
	text-align: right;

	&:first-child {
		text-align: left;
	}
}

.bodyRow {
	border-bottom: 1px solid $gray-50;
}

.cellLeft {
	padding: 8px 12px;
}

.cellRight {
	padding: 8px 12px;
	text-align: right;
}

.centerName {
	font-weight: 500;
}

.emptyRow {
	padding: 24px 12px;
	text-align: center;
	color: $gray-400;
}

.addButton {
	margin-top: 16px;
}

.cellAction {
	padding: 8px 12px;
	text-align: center;
	width: 60px;
}
